import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { enumPaymentState } from '../enums/payments';
import { enumCompanyPaymentType } from '../enums/companies';

@Injectable({
  providedIn: 'root',
})
export class PaymentsRepository {
  constructor(private apiService: ApiService) {}

  public create(
    billId: number,
    offSession: boolean = false,
  ): Observable<{
    paymentId: string;
    paymentState: enumPaymentState;
    paymentType: enumCompanyPaymentType;
  }> {
    return this.apiService.post<{
      paymentId: string;
      paymentState: enumPaymentState;
      paymentType: enumCompanyPaymentType;
    }>(`${environment.url.prefixCustoms}v3/payments`, null, {
      params: {
        billId,
        offSession,
      },
    });
  }

  public confirmBillBankPayment(billId: number): Observable<void> {
    return this.apiService.post<void>(environment.url.bankPayments, null, {
      params: {
        billId,
      },
    });
  }

  public execute(data: {
    orderId: string;
    payerId: string;
    returnUrl: string;
    intent: string;
    paymentId: string;
    paymentToken: string;
  }): Observable<{
    state: enumPaymentState;
  }> {
    return this.apiService.put<{
      state: enumPaymentState;
    }>(`${environment.url.prefixCustoms}v3/payments/${data.paymentId}`, data);
  }

  public cancel(paymentId: string): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v3/payments/${paymentId}`);
  }
}
